import { Typography } from "@mui/material";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";

import { ErrorBox } from "components/primitives/ErrorBox";

export const ModalSupportFooter = ({
	fridgeId,
	background,
}: {
	fridgeId: string;
	background?: string;
}) => {
	const { t } = useTranslation();

	return (
		<>
			<ErrorBox mt={"auto"} background={background}>
				<Typography
					display={"flex"}
					variant={"ctaSubtextBold"}
					color={"white"}
					textAlign={"center"}
				>
					{parse(t("modals.error.buttonText"))}
				</Typography>
			</ErrorBox>
			<Typography mt={1} fontWeight={600}>
				{t("modals.error.fridgeId", { fridgeId: fridgeId })}
			</Typography>
		</>
	);
};
